
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocation as ObiLocationElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location.js';
 
 
 

 
 export const ObiLocation = createComponent({
   react: React,
   tagName: 'obi-location',
   elementClass: ObiLocationElement,
   events: {
     
   }
  });
 
 